export default __webpack_public_path__ + "static/media/appleStore.a3acfc14.svg";